import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setBlindBatch, setScanBatchList, getMachineConfig } from '../../../../actions/saActions';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from '../../../../reducers/uiSlice';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme)=> ({
    container: {
        display: 'flex',
        marginBottom: 20,
        flexDirection: 'column'
    },
    input: {
        width: 250,
        marginRight: 5
    },
    inputButton: {
        display: 'flex',
        alignItems: 'baseline',
        marginTop: 10,
    },
    marginRight: {
        marginRight: 20
    }
}))

function BlindBatch(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation('slotAssignment');
    const history = useHistory();

    const [input, setInput] = useState('');

    return (
        <Box color="text.primary" className={classes.container}>
            <div className={classes.marginRight}>
                <span>{t('set_as_current_blind_batch')}</span>
                
            </div>
            <div className={classes.inputButton}>
                {
                    (!props.blindBatch ||
                    props.blindBatch.length <= 0) ?
                    <div 
                        style={{color:'red',fontWeight:'bold',cursor:'pointer'}}
                        onClick={()=>history.push('/batch-management')}
                    >
                        {t('no_blind_batch')}
                    </div>
                    :
                    <div>
                        <TextField
                            fullWidth
                            select
                            label={t('blind_batch')}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            value={input}
                            onChange={(e)=>{setInput(e.target.value)}}
                            className={classes.input}
                        >
                            {props.blindBatch.map((blindBatch) => (
                                <option key={blindBatch.id} value={blindBatch.master_air_waybill}>
                                    {blindBatch.master_air_waybill}
                                </option>
                            ))}
                        </TextField>
                        <Button variant="contained" color="primary" onClick={() => {setCurrentBlindBatchToScan(input)}}>{t('set')}</Button>
                    </div>
                }
            </div>
        </Box>
    );

    function setCurrentBlindBatchToScan(blindBatch) {
        dispatch(setScanBatchList(props.branch, blindBatch))
        .then(() => {
            dispatch(showAlertSnackbar({
                message: t('set_blind_batch_to_scan_success'),
                type: 'success'
            }))
            dispatch(getMachineConfig(props.branch));
        })
        .catch(() => {
            dispatch(showAlertSnackbar({
                message: t('set_blind_batch_to_scan_fail'),
                type: 'error'
            }))
        })
    }
}

export default BlindBatch;